module.exports = __webpack_public_path__ + "static/img/mob-4.31c878fa.jpeg";